import { useEffect, useState } from 'react';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';

export const usePresence = (roomId) => {
    const socket = useSocket();
    const { user } = useAuth();
    const [activeUsers, setActiveUsers] = useState([]);

    useEffect(() => {
        if (!socket || !roomId || !user) {
            console.log("usePresence: Missing dependencies", { hasSocket: !!socket, roomId, hasUser: !!user });
            return;
        }

        console.log(`usePresence: Joining room ${roomId} as ${user.email}`);

        // Join room when component mounts or roomId/user/socket changes
        socket.emit('join_room', { roomId, user });

        // Listen for updates about users in the room
        const handleRoomUsers = (users) => {
            console.log(`usePresence: Received users for room ${roomId}:`, users);
            setActiveUsers(users);
        };

        socket.on('room_users', handleRoomUsers);

        // Cleanup: leave room and remove listener
        return () => {
            socket.emit('leave_room', { roomId });
            socket.off('room_users', handleRoomUsers);
        };
    }, [socket, roomId, user]);

    return activeUsers;
};
